import {cn} from '@cohort/shared-frontend/utils/classNames';
import {isDark} from '@cohort/shared-frontend/utils/isDark';

type PreviewPrimaryButtonProps = {
  accentColorCode: string;
  text: string | JSX.Element;
};

const PreviewPrimaryButton: React.FC<PreviewPrimaryButtonProps> = ({accentColorCode, text}) => {
  const hasDarkAccent = isDark(accentColorCode);

  return (
    <button
      className={cn(
        'flex h-11 w-full items-center justify-center rounded-lg text-sm font-semibold',
        hasDarkAccent ? 'text-white' : 'text-black/90'
      )}
      style={{backgroundColor: accentColorCode}}
      type="button"
    >
      {text}
    </button>
  );
};

export default PreviewPrimaryButton;
